import { RootState } from "configs/store/types";
import useSelector from "./useSelector";

const selector = (state: RootState) => state.offline.online;

const useOnline = () => useSelector(selector);

export default useOnline;
